// Auto-generated span name constants.

export const SPAN_NAMES = {
  octomilResponse: "octomil.response",
  octomilModelLoad: "octomil.model.load",
  octomilControlRefresh: "octomil.control.refresh",
  octomilControlHeartbeat: "octomil.control.heartbeat",
  octomilToolExecute: "octomil.tool.execute",
  octomilFallbackCloud: "octomil.fallback.cloud",
  octomilRolloutSync: "octomil.rollout.sync",
  octomilArtifactDownload: "octomil.artifact.download",
  octomilArtifactActivation: "octomil.artifact.activation",
  octomilFederationRound: "octomil.federation.round",
  octomilTrainingJob: "octomil.training.job",
  octomilDeviceSync: "octomil.device.sync",
  octomilTelemetryUpload: "octomil.telemetry.upload",
} as const;

export const ALL_SPAN_NAMES = Object.values(SPAN_NAMES);
